module.exports = __webpack_public_path__ + "media/images/vp/icon.dropdown.black-b98c6ce6d42a04963a23784d34b72b8e.svg";